<template>
  <div>
    <span v-html="formatedStatus"></span>
  </div>
</template>
<script>

import moment from "moment";

export default {
  name: 'CellRendererDate',
  data() {
    return {
      formatedStatus: ''
    }
  },
  mounted() {
    if (this.params.value) {
      if (moment(this.params.value).format("DD/MM/YYYY") === '01/01/1970') {
        this.formatedStatus = '';
      } else {
        this.formatedStatus = moment(this.params.value).format("DD/MM/YYYY");
      }
    }
  },
}
</script>


